import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import HotComics from './components/HotComics';
import { Link } from 'react-router-dom';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '全职法师漫画-在线免费阅读下拉式漫画-073漫画网',
    description: '在073漫画网，您可以享受全职法师漫画的在线免费阅读，支持下拉式浏览，随时随地畅享精彩剧情。',
    url: 'https://073comic.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '073漫画网',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <main>
        <HeroSection />
        <FeaturedComics />
        <CategorySection />
        <LatestUpdates />
        <HotComics />

        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-7xl mx-auto">
            <div className="rounded-2xl bg-gradient-to-r from-primary-500 to-accent-500 p-8 md:p-12 text-center">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
                随时随地，畅享阅读
              </h2>
              <p className="text-background-100/90 text-sm md:text-base max-w-lg mx-auto mb-8 leading-relaxed">
                073漫画网支持手机、平板、电脑多端阅读，下拉式浏览让阅读更流畅。全职法师等千余部漫画等你来读！
              </p>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-50 text-primary-600 hover:bg-background-100 font-medium text-sm transition-all duration-200 whitespace-nowrap"
              >
                立即探索 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}